import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { roleHome, isPathAllowedForRole } from "@/lib/rolePolicy";

export default function ProtectedRoute({ children, allow }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center bg-slate-100">
                <div className="text-slate-500 text-sm font-mono">Cargando...</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;

    // Si la ruta declara explícitamente qué roles la pueden ver y este usuario no, redirige a su home
    if (allow && Array.isArray(allow) && !allow.includes(user.role)) {
        return <Navigate to={roleHome(user)} replace />;
    }

    // Gate centralizado por path: ambulancia y cliente solo pueden navegar a sus paths permitidos
    if (!isPathAllowedForRole(location.pathname, user.role)) {
        return <Navigate to={roleHome(user)} replace />;
    }

    return children;
}
